import * as React from "react";
import SelectHybrid from "./SelectHybrid";
import type { TypeSelectProps } from "./SelectTypes";

/**
 * Select component. Automatically routes between the Tailwind implementation
 * (preferred) and the styled-components implementation (for consumers using
 * system props or styled() extension).
 */
const Select = (props: TypeSelectProps) => <SelectHybrid {...props} />;

Select.displayName = "Select";

export default Select;
